import {useState} from 'react'

function useDrawerControl () {
    const [open, setOpen] = useState(true)

    const toggleDrawer = () => {
        setOpen(prev => (!prev))
    }

    return {open ,toggleDrawer}
}
export default useDrawerControl